// extracted by mini-css-extract-plugin
export var container = "_mb-0";
export var segment = "_mb-2";
export var segmentActive = "_mb-3";
export var track = "_mb-1";